import React from 'react';
import { Container } from 'reactstrap';
import { ParameterSearch } from './ParameterSearch';
import { ParameterResultList } from './ParameterResultList';


/**
 * 
 */
export const Parameters: React.FC<{}> = (): JSX.Element => {
  return (
    <Container className="p-4" fluid>
      <ParameterSearch />
      <ParameterResultList />
    </Container>
  );
};
